import { render, staticRenderFns } from "./UnequalAllocation.vue?vue&type=template&id=cf09b950&scoped=true"
import script from "./UnequalAllocation.vue?vue&type=script&lang=js"
export * from "./UnequalAllocation.vue?vue&type=script&lang=js"
import style0 from "./UnequalAllocation.vue?vue&type=style&index=0&id=cf09b950&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf09b950",
  null
  
)

export default component.exports